import { render, staticRenderFns } from "./HomeStatisticheAttivita.vue?vue&type=template&id=2cba465a&"
import script from "./HomeStatisticheAttivita.vue?vue&type=script&lang=js&"
export * from "./HomeStatisticheAttivita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports